import { Typography } from "@mui/material";

import CheckboxGroup from "@/components/CheckboxGroup";

import { useFilterContext } from "../FilterContext";

const FilterItemBanks = () => {
  const { filterData, setFilterData, filterOptions, filterOptionsCount, cabinPriceMap } =
    useFilterContext();
  return (
    <CheckboxGroup
      options={filterOptions.cabinsOptions.map((item) => ({
        ...item,
        label: (
          <div className="my-[5px]">
            <Typography>
              {`${item.label} (${filterOptionsCount["cabins"][
                item.value
              ]?.progress.toLocaleString()}
              /${filterOptionsCount["cabins"][item.value]?.total.toLocaleString()})`}
            </Typography>
            <div className="flex">
              From{" "}
              <Typography color="primary" className="pl-[6px] pr-[3px]" fontWeight="bold">
                {Number(cabinPriceMap?.get(item.value)?.awardPoints ?? 0).toLocaleString()} pts + ${cabinPriceMap?.get(item.value)?.tax ?? 0}
              </Typography>
            </div>
          </div>
        ),
      }))}
      value={
        filterData.cabins.length > 0
          ? filterData.cabins
          : filterOptions.cabinsOptions.map(({ value }) => value)
      }
      onChange={(value) => {
        setFilterData({
          cabins: value.length === filterOptions.cabinsOptions.length ? [] : value,
        });
      }}
    />
  );
};

export default FilterItemBanks;
